// Duits (de-DE), hallway: het bord in de gang van een gedeelde woning (golf 6b).
export const hallwayDe = {
    thisWeek: 'Diese Woche dran',
    today: 'Heute',
    cooks: '{name} kocht',
    nobody: 'Niemand',
    done: 'Erledigt',
    doneBy: 'Erledigt von {name}',
    tapHint: 'Tippe auf eine Aufgabe, wenn sie erledigt ist',
    whoDid: 'Wer hat {duty} gemacht?',
    saved: '{duty}: erledigt von {name}',
    undo: 'Hoppla, rückgängig',
    undone: 'Rückgängig gemacht',
    agenda: 'Hauskalender',
    nothingPlanned: 'Nichts geplant',
    close: 'Schließen',
    allDone: 'Diese Woche ist alles erledigt',
    noDuties: 'Noch kein Putzplan. Erstelle ihn in der App unter Putzplan.',
};
//# sourceMappingURL=hallway.de.js.map